module.exports = __webpack_public_path__ + "img/down.f1a361e1.svg";